import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import { useState, useRef } from 'react';

function Web({ webStatus, setPopupStyle }) {
  const apiUrl = process.env.REACT_APP_API_DOMAIN + `yeonoo/monitoring/web/status/detail?webStatus=${webStatus}`;
  const dataSource = {
    api: {
      readData: { url: apiUrl, method: 'GET' }
    }
  };

  const columnArray = [
    { name: 'name', header: '웹', align: 'center', width: 'auto' },
    { name: 'connection_time', header: '접속 시각', align: 'center', width: 130 },
    { name: 'domain_connection_time', header: '접속 시각(도메인)', align: 'center', width: 130 },
    { name: 'ip', header: 'IP', align: 'center', width: 'auto' },
    { name: 'port', header: 'Port', align: 'center', width: 'auto' },
    { name: 'url', header: 'URL', align: 'center', width: 'auto' }
  ];
  const gridReference = useRef(); // 그리드 참조
  const [grid, setGrid] = useState(
    <Grid
      ref={gridReference} //그리드 참조
      width={'100%'}
      bodyHeight={'auto'}
      data={dataSource}
      columns={columnArray}
      rowHeaders={['rowNum']}
      onResponse={OnResponse} //서버 응답
      onGridUpdated={OnGridUpdated}
      onClick={OnClick}
    />
  );

  const [mainStyle, setMainStyle] = useState({});
  const [iframeOption, setIframeOption] = useState({ visible: false, source: '' });
  function CloseIframe() {
    if (iframeOption.visible) {
      iframeOption.visible = false;
      iframeOption.source = '';
      iframeOption.name = '';
      setIframeOption(iframeOption);
      setMainStyle({});
      }
  }
  function OnClick(event) {
    const instance = event.instance;
    if (instance.getValue(event.rowKey, 'url') !== '') {
      iframeOption.visible = true;
      iframeOption.source = instance.getValue(event.rowKey, 'url');
      iframeOption.name = instance.getValue(event.rowKey, 'name');
      setIframeOption(iframeOption);
    } else {
      iframeOption.visible = true;
      iframeOption.source = `http://${instance.getValue(event.rowKey, 'ip')}:${instance.getValue(event.rowKey, 'port')}`;
      iframeOption.name = instance.getValue(event.rowKey, 'name');
      setIframeOption(iframeOption);
    }
    setMainStyle({ opacity: 0.5, userSelect: 'none' });
  }

  function OnGridUpdated(event) {
    let allColumnWidth = 0;
    const tempColumnArray = [...columnArray];
    const columns = gridReference.current.getInstance().getColumns();
    for (const index1 in columns) {
      for (const index2 in tempColumnArray) {
        if (tempColumnArray[index2].name === columns[index1].name) {
          if (columns[index1].autoResizing === true) {
            //컬럼 사이즈가 오토로 지정됐다면 width에 + 10하여 셀 내용 잘림 방지
            tempColumnArray[index2].width = columns[index1].baseWidth + 10;
          }
          
          //그리드의 width를 정하기 위해 총 컬럼 width를 구함
          allColumnWidth += tempColumnArray[index2].width;
        }
      }
    }
    event.instance.setColumns(tempColumnArray);

    setPopupStyle((previousState) => {
      const previousStyle = {...previousState};
      
      const height = gridReference.current.getInstance().getRowCount() * 40 + 104;
      const maxHeight = window.innerHeight * 0.8;
      const minHeight = 217;
      if (height >= maxHeight) {
        previousStyle.content.height = maxHeight;
      } else if (height >= minHeight) {
        previousStyle.content.height = height;
      } else {
        previousStyle.content.height = minHeight;
      }

      //그리드 height 적용, 두 코드 모두 사용 가능
      event.instance.setBodyHeight(previousStyle.content.height - (87));
      //event.instance.setHeight(previousStyle.content.height - (46));

      const width = allColumnWidth + 61;
      const maxWidth = window.innerWidth * 0.9;
      if (width >= maxWidth) {
        previousStyle.content.width = maxWidth;
      } else {
        previousStyle.content.width = width;  
      }

      return previousStyle;
    });
  }

  function OnResponse(event) {
    const response = JSON.parse(event.xhr.response);

    if (!response.result) {
      alert(`(${response.apiUrl}) ${response.apiMethod} API 실패\n${response.message}`);
    }
  }

  return (
    <div>
      <div style={mainStyle}>
        {grid}
      </div>

      {iframeOption.visible && 
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', height: '80%', zIndex: 15, backgroundColor: 'white', border: '2px solid black', borderRadius: '7px' }}>
        <div style={{ width: '100%', backgroundColor: 'rgb(18, 46, 78)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', /*cursor: 'move',*/ userSelect: 'none' }}>
          <span style={{ color: 'white', margin: '10px' }}>{iframeOption.name}</span>
          <button style={{ width: '25px', margin: '10px' }} onClick={CloseIframe}>✕</button>
        </div>
        <iframe title='WebConnectionTest' src={iframeOption.source} style={{ width: 'calc(100% - 5px)', height:'calc(100% - 50px)' }}/>
      </div>}
    </div>
  );
}

export default Web;